export default __webpack_public_path__ + "static/media/Logo fix full color.ef8e6daa.png";